import { render, staticRenderFns } from "./Internal-Note-Attachment-Detail.vue?vue&type=template&id=5eadb234&"
import script from "./Internal-Note-Attachment-Detail.vue?vue&type=script&lang=js&"
export * from "./Internal-Note-Attachment-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports